const serviceCatalog = {
  aiAutomation: {
    imageKey: "aiAutomation",
    slugs: {
      no: "ai-automatisering",
      en: "ai-automation",
    },
    legacyAliases: ["aiAutomation"],
    title: {
      no: "AI-arbeidsflyt og agentstøtte",
      en: "AI Workflows and Agent Support",
    },
    teaser: {
      no: "Bygg kontrollerte AI-steg for henvendelser, tilbud, dokumentflyt og oppfølging uten å miste ansvar eller kvalitet.",
      en: "Build controlled AI steps for inquiries, quoting, document flow, and follow-up without losing ownership or quality.",
    },
    summary: {
      no: "For bedrifter som bruker for mye tid på e-post, manuell ruting og repetitive oppgaver i kundereisen eller intern administrasjon.",
      en: "For businesses spending too much time on email, manual routing, and repetitive work across the customer journey or internal administration.",
    },
    forWhom: {
      no: [
        "Tjenestebedrifter med mye manuell oppfølging",
        "Team som vil bruke AI praktisk og kontrollert",
        "Virksomheter som trenger bedre flyt mellom skjema, e-post og CRM",
      ],
      en: [
        "Service businesses with too much manual follow-up",
        "Teams that want practical, controlled AI adoption",
        "Companies needing cleaner flow between forms, email, and CRM",
      ],
    },
    problems: {
      no: [
        "Leads og henvendelser må sorteres og svares på manuelt",
        "Tilbud og dokumenter blir sendt, fulgt opp og lagret ustrukturert",
        "Mye tid går til påminnelser, booking og neste steg i kundedialogen",
      ],
      en: [
        "Leads and inquiries are sorted and handled manually",
        "Quotes and documents are sent, followed up, and stored inconsistently",
        "Too much time goes to reminders, booking, and next steps in customer handling",
      ],
    },
    deliverables: {
      no: [
        "Kartlegging av dagens arbeidsflyt og risiko",
        "Automatisering av ruting, oppfølging eller dokumentbehandling",
        "Integrasjon mot Microsoft 365, CRM, skjema eller bookingløsning",
        "Logging, kvalitetssikring og enkel dokumentasjon",
      ],
      en: [
        "Assessment of current workflow and operational risk",
        "Automation of routing, follow-up, or document handling",
        "Integration with Microsoft 365, CRM, forms, or booking systems",
        "Logging, quality control, and clean documentation",
      ],
    },
    engagement: {
      no: "Typisk som en avgrenset sprint med kartlegging, pilot og justering etter faktisk bruk.",
      en: "Typically delivered as a focused sprint with assessment, pilot, and post-launch adjustments.",
    },
    technologies: ["OpenAI", "Azure AI", "Power Automate", "Microsoft 365", "Python"],
  },
  powerBiAnalytics: {
    imageKey: "powerBiAnalytics",
    slugs: {
      no: "power-bi-dataanalyse",
      en: "power-bi-data-analytics",
    },
    legacyAliases: ["powerBiAnalytics", "dataAnalytics"],
    title: {
      no: "Styringsdata og Power BI",
      en: "Management Data and Power BI",
    },
    teaser: {
      no: "Bygg et beslutningsbilde som viser tallene som faktisk styrer margin, kontantstrøm, pipeline og kapasitet.",
      en: "Build a decision layer that surfaces the numbers that actually drive margin, cash flow, pipeline, and capacity.",
    },
    summary: {
      no: "For ledere og økonomimiljøer som trenger mindre regnearkarbeid og bedre beslutningsgrunnlag fra økonomi-, salgs- og driftsdata.",
      en: "For leaders and finance teams that need less spreadsheet work and better decision support from finance, sales, and operations data.",
    },
    forWhom: {
      no: [
        "Ledelse som vil ha ett felles styringsbilde",
        "Økonomi- og regnskapsmiljøer som pakker rapporter manuelt",
        "Bedrifter som vil bygge KPI-er de faktisk kan styre etter",
      ],
      en: [
        "Leadership teams wanting one shared decision layer",
        "Finance environments still assembling reports manually",
        "Businesses wanting KPIs they can actually manage against",
      ],
    },
    problems: {
      no: [
        "Tallene ligger i forskjellige systemer og blir lite brukt i praksis",
        "Definisjoner og KPI-er er uklare eller endrer seg mellom rapporter",
        "Rapportering tar for lang tid hver uke eller måned",
      ],
      en: [
        "The numbers live in different systems and rarely support daily decisions",
        "Metric definitions and KPIs are unclear or shift between reports",
        "Reporting takes too much time every week or month",
      ],
    },
    deliverables: {
      no: [
        "KPI-workshop og avklaring av ledelsesbehov",
        "Power BI-dashbord med datamodell og nødvendige måltall",
        "Datakoblinger mot økonomi, CRM, Excel eller andre kilder",
        "Dokumentasjon av definisjoner og eierskap",
      ],
      en: [
        "KPI workshop and leadership requirements mapping",
        "Power BI dashboard with a clean data model and usable metrics",
        "Data connections to finance, CRM, Excel, or other sources",
        "Documentation of definitions and ownership",
      ],
    },
    engagement: {
      no: "Typisk som en analyse- og dashboardleveranse med rask førsteversjon og forbedringer i tett dialog med ledelsen.",
      en: "Typically delivered as an analytics and dashboard engagement with a fast first version and close iteration with leadership.",
    },
    technologies: ["Power BI", "Microsoft Fabric", "SQL", "Tripletex/Fiken", "DAX"],
  },
  dataPlatform: {
    imageKey: "dataPlatform",
    slugs: {
      no: "dataplattform-data-warehouse",
      en: "data-platform-data-warehouse",
    },
    legacyAliases: ["dataPlatform"],
    title: {
      no: "Dataplattform og Microsoft Fabric",
      en: "Data Platform and Microsoft Fabric",
    },
    teaser: {
      no: "Rydd opp i datakilder, modellering og pipelines slik at rapportering og automasjon står på et mer robust grunnlag.",
      en: "Clean up data sources, modeling, and pipelines so reporting and automation rest on a more reliable foundation.",
    },
    summary: {
      no: "For virksomheter som allerede har flere systemer, men mangler et ryddig datagrunnlag for rapportering, analyse eller videre automatisering.",
      en: "For companies that already have multiple systems but lack a clean data foundation for reporting, analysis, or further automation.",
    },
    forWhom: {
      no: [
        "Selskaper med flere datakilder og voksende rapportbehov",
        "Team som vil standardisere pipeline, modellering og kvalitet",
        "Miljøer som vurderer Fabric, dbt, Azure eller annen moderne stack",
      ],
      en: [
        "Companies with multiple data sources and growing reporting needs",
        "Teams wanting standardized pipelines, modeling, and quality controls",
        "Environments evaluating Fabric, dbt, Azure, or similar modern stacks",
      ],
    },
    problems: {
      no: [
        "Rapporter bygger på manuelle uttrekk og sårbare avhengigheter",
        "Datamodellen er uoversiktlig eller mangler kvalitetssjekker",
        "Det er uklart hva som bør ligge i kildesystem, lager og rapportlag",
      ],
      en: [
        "Reports depend on manual extracts and fragile handoffs",
        "The data model is messy or lacks quality controls",
        "It is unclear what should live in source systems, the warehouse, and the reporting layer",
      ],
    },
    deliverables: {
      no: [
        "Vurdering av dagens dataplattform og arkitekturvalg",
        "Design av datamodell, pipeline og rapportlag",
        "Implementering eller opprydding i Microsoft Fabric, SQL eller tilsvarende",
        "Dokumentasjon av kvalitet, eierskap og videre drift",
      ],
      en: [
        "Assessment of current data platform and architecture choices",
        "Design of data model, pipeline, and reporting layer",
        "Implementation or cleanup in Microsoft Fabric, SQL, or similar tooling",
        "Documentation of quality controls, ownership, and future operations",
      ],
    },
    engagement: {
      no: "Typisk som en health check eller en avgrenset modernisering av rapport- og pipelinegrunnlaget.",
      en: "Typically delivered as a health check or a focused modernization of the reporting and pipeline foundation.",
    },
    technologies: ["Microsoft Fabric", "Azure", "dbt", "SQL", "Power BI"],
  },
  internalTools: {
    imageKey: "internalTools",
    slugs: {
      no: "interne-verktoy-webutvikling",
      en: "internal-tools-web-development",
    },
    legacyAliases: ["internalTools", "digitalConsulting"],
    title: {
      no: "Interne verktøy og webflyt",
      en: "Internal Tools and Web Flows",
    },
    teaser: {
      no: "Bygg enkle interne verktøy, bookingflyter og kundevendte softwareflater som støtter driften.",
      en: "Build focused internal tools, booking flows, and customer-facing software that supports operations.",
    },
    summary: {
      no: "For bedrifter som trenger et praktisk verktøy eller en nettside som må henge tett sammen med oppfølging, økonomi eller andre interne rutiner.",
      en: "For businesses that need a practical tool or website tightly connected to follow-up, finance, or internal operating routines.",
    },
    forWhom: {
      no: [
        "Tjenestebedrifter som vil forbedre lead- og bookingflyt",
        "Team som trenger et internt verktøy i stedet for enda et regneark",
        "Virksomheter som vil koble nettside, CRM og drift tettere sammen",
      ],
      en: [
        "Service businesses improving lead and booking flow",
        "Teams needing an internal tool instead of another spreadsheet",
        "Companies wanting tighter links between website, CRM, and operations",
      ],
    },
    problems: {
      no: [
        "Nettsiden skaper ikke nok kvalifiserte henvendelser",
        "Interne oppgaver løses i regneark og manuelle lister",
        "Kundeprosesser og backoffice henger ikke godt nok sammen",
      ],
      en: [
        "The website does not generate enough qualified inquiries",
        "Internal tasks are still handled in spreadsheets and manual lists",
        "Customer flows and back-office routines do not connect properly",
      ],
    },
    deliverables: {
      no: [
        "Kartlegging av brukerflyt og forretningsbehov",
        "Nettside, bookingflyt eller internt verktøy med tydelig scope",
        "Integrasjon mot CRM, e-post, booking eller rapportering ved behov",
        "Lansering, dokumentasjon og forslag til neste iterasjon",
      ],
      en: [
        "Assessment of user flow and business needs",
        "Website, booking flow, or internal tool with clear scope",
        "Integration with CRM, email, booking, or reporting when needed",
        "Launch, documentation, and recommended next iteration",
      ],
    },
    engagement: {
      no: "Typisk som et avgrenset produkt- eller prosessoppdrag der målet er rask forbedring, ikke en tung utviklingsorganisasjon.",
      en: "Typically delivered as a focused product or process engagement aimed at fast improvement rather than a heavy development programme.",
    },
    technologies: ["React", "Next.js", "Supabase", "CRM", "Booking integrations"],
  },
  financialServices: {
    imageKey: "financialServices",
    slugs: {
      no: "finansielle-tjenester",
      en: "financial-services",
    },
    legacyAliases: ["financialServices", "finance"],
    title: {
      no: "Økonomiflyt og finansiell kontroll",
      en: "Finance Workflows and Financial Control",
    },
    teaser: {
      no: "Koble bokføring, avstemming og rapportering slik at økonomifunksjonen bruker tiden på kontroll og beslutninger.",
      en: "Connect bookkeeping, reconciliation, and reporting so finance spends time on control and decisions.",
    },
    summary: {
      no: "For bedrifter som vil ha tettere kontroll på kontantstrøm, margin og MVA – uten et tungt økonomisystem. Vi kobler regnskap, bank, CRM og Power BI i én flyt.",
      en: "For businesses that want tighter control over cash flow, margin, and VAT without building a heavy finance system. We connect accounting, banking, CRM, and Power BI into one controlled flow.",
    },
    forWhom: {
      no: [
        "Daglige ledere som trenger sanntidsoversikt over kontantstrøm og margin",
        "Økonomiansvarlige som bruker for mye tid på manuell avstemming og rapporter",
        "Bedrifter med vekst der regnskap, fakturering og rapportering ikke lenger henger sammen",
      ],
      en: [
        "CEOs who need real-time visibility into cash flow and margin",
        "Finance leads spending too much time on manual reconciliation and reporting",
        "Growing businesses where bookkeeping, invoicing, and reporting no longer connect",
      ],
    },
    problems: {
      no: [
        "Bokføring og avstemming tar dager hver måned i stedet for timer",
        "Ledergruppen får tall for sent til å ta gode beslutninger",
        "MVA, periodisering og compliance blir jobbet fram manuelt hver termin",
        "Fakturering, inkasso og oppfølging henger ikke sammen med CRM og bank",
      ],
      en: [
        "Bookkeeping and reconciliation take days each month instead of hours",
        "Leadership gets numbers too late to make good decisions",
        "VAT, accruals, and compliance work are produced manually every period",
        "Invoicing, collections, and follow-up are disconnected from CRM and banking",
      ],
    },
    deliverables: {
      no: [
        "Automatisert avstemming mellom regnskap, bank og betalingsløsninger",
        "Månedlig styringsrapport med kontantstrøm, margin og prognoser i Power BI",
        "MVA- og avgiftsflyt med kontrollpunkter og dokumentasjon",
        "Fakturering, purring og inkassoflyt integrert mot CRM og bank",
        "Budsjett- og prognosemodell som ledergruppen faktisk bruker",
      ],
      en: [
        "Automated reconciliation between accounting, banking, and payment providers",
        "Monthly controller report in Power BI with cash flow, margin, and forecast",
        "VAT and tax flow with controls, ownership, and documentation",
        "Invoicing, dunning, and collections integrated with CRM and banking",
        "Budget and forecast model that leadership actually uses",
      ],
    },
    engagement: {
      no: "Typisk som en fokusert sprint der vi kartlegger økonomiprosessen, automatiserer det tyngste og leverer en styringsrapport som ledergruppen kan stole på.",
      en: "Typically delivered as a focused sprint that maps the finance process, automates the heaviest parts, and delivers a controller report leadership can trust.",
    },
    technologies: ["Power BI", "Microsoft Fabric", "Tripletex", "PowerOffice Go", "Fiken", "Dynamics 365", "Azure AI", "Power Automate"],
  },
};

export function getServiceIds() {
  return Object.keys(serviceCatalog);
}

export function getServiceById(serviceId) {
  return serviceCatalog[serviceId] ?? null;
}

export function resolveServiceId(value) {
  if (!value) return null;
  const normalized = value.trim();
  if (serviceCatalog[normalized]) return normalized;

  return (
    Object.entries(serviceCatalog).find(([, service]) => {
      const aliases = [
        ...(service.legacyAliases ?? []),
        service.slugs.no,
        service.slugs.en,
      ];
      return aliases.includes(normalized);
    })?.[0] ?? null
  );
}

export function getServicePath(serviceId, language = "no") {
  const service = getServiceById(serviceId);
  if (!service) return language === "no" ? "/no/services" : "/en/services";

  const slug = language === "no" ? service.slugs.no : service.slugs.en;
  return language === "no" ? `/no/${slug}` : `/en/${slug}`;
}

export function getLocalizedService(serviceId, language = "no") {
  const service = getServiceById(serviceId);
  if (!service) return null;

  return {
    ...service,
    id: serviceId,
    title: service.title[language] ?? service.title.en,
    teaser: service.teaser[language] ?? service.teaser.en,
    summary: service.summary[language] ?? service.summary.en,
    forWhom: service.forWhom[language] ?? service.forWhom.en,
    problems: service.problems[language] ?? service.problems.en,
    deliverables: service.deliverables[language] ?? service.deliverables.en,
    engagement: service.engagement[language] ?? service.engagement.en,
  };
}
